var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnBreak(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_41742",
    "data-name": "Group 41742",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.106,
    height: 19.839,
    viewBox: "0 0 18.106 19.839",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_61992",
    "data-name": "Path 61992",
    d: "M59.519,6.251l-.15.438a.573.573,0,0,0,.224.675.272.272,0,0,0,.165.037.425.425,0,0,0,.389-.31l.15-.438a2.283,2.283,0,0,0-.224-1.972,1.072,1.072,0,0,1-.06-1.041l.179-.365a.6.6,0,0,0-.135-.712.387.387,0,0,0-.583.164l-.179.365a2.312,2.312,0,0,0,.12,2.227A1.068,1.068,0,0,1,59.519,6.251Z",
    transform: "translate(-47.041 -2.488)",
    fill: "#deaa0c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_61993",
    "data-name": "Path 61993",
    d: "M45.419,6.251l-.15.438a.573.573,0,0,0,.224.675.272.272,0,0,0,.165.037.425.425,0,0,0,.389-.31l.15-.438a2.283,2.283,0,0,0-.224-1.972,1.072,1.072,0,0,1-.06-1.041l.18-.365a.6.6,0,0,0-.135-.712.387.387,0,0,0-.583.164l-.18.365a2.312,2.312,0,0,0,.12,2.227A1.12,1.12,0,0,1,45.419,6.251Z",
    transform: "translate(-34.803 -2.488)",
    fill: "#deaa0c"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_61994",
    "data-name": "Path 61994",
    d: "M31.219,6.251l-.15.438a.573.573,0,0,0,.224.675.272.272,0,0,0,.165.037.425.425,0,0,0,.389-.31L32,6.652a2.283,2.283,0,0,0-.224-1.972,1.072,1.072,0,0,1-.06-1.041l.179-.365a.6.6,0,0,0-.135-.712.387.387,0,0,0-.583.164l-.18.365a2.312,2.312,0,0,0,.12,2.227A1.12,1.12,0,0,1,31.219,6.251Z",
    transform: "translate(-22.466 -2.488)",
    fill: "#deaa0c"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_61995",
    "data-name": "Path 61995",
    d: "M27.157,37.159H24.58V35.838a.632.632,0,0,0-.627-.638H13.263a.632.632,0,0,0-.627.638v3.6a2.8,2.8,0,0,0,.022.433,4.932,4.932,0,1,0,5.737,7.61h1.9a2.616,2.616,0,0,0,2.174-1.162,12.056,12.056,0,0,0,1.636-3.486h.829a2.9,2.9,0,0,0,2.868-2.916V37.775A.663.663,0,0,0,27.157,37.159ZM14.54,48.119a3.669,3.669,0,1,1,3.608-3.668A3.636,3.636,0,0,1,14.54,48.119Zm8.784-8.658a10.844,10.844,0,0,1-1.9,6.175,1.4,1.4,0,0,1-1.143.615H19.089a5.107,5.107,0,0,0,.336-1.777,4.9,4.9,0,0,0-4.863-4.944,5.824,5.824,0,0,0-.65.046V36.521h9.434v2.939Zm3.2.5a1.611,1.611,0,0,1-1.591,1.618H24.4a13.56,13.56,0,0,0,.2-2.119v-1h1.927Z",
    transform: "translate(-9.7 -29.533)",
    fill: "#deaa0c"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_61996",
    "data-name": "Path 61996",
    d: "M30.778,65.819h-1V64.338a.638.638,0,0,0-1.276,0v2.119a.637.637,0,0,0,.638.638h1.64a.637.637,0,0,0,.638-.638A.623.623,0,0,0,30.778,65.819Z",
    transform: "translate(-24.3 -51.539)",
    fill: "#deaa0c"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_61997",
    "data-name": "Path 61997",
    d: "M59.519,6.251l-.15.438a.573.573,0,0,0,.224.675.272.272,0,0,0,.165.037.425.425,0,0,0,.389-.31l.15-.438a2.283,2.283,0,0,0-.224-1.972,1.072,1.072,0,0,1-.06-1.041l.179-.365a.6.6,0,0,0-.135-.712.387.387,0,0,0-.583.164l-.179.365a2.312,2.312,0,0,0,.12,2.227A1.068,1.068,0,0,1,59.519,6.251Z",
    transform: "translate(-52.628 -2.488)",
    fill: "#deaa0c"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_61998",
    "data-name": "Path 61998",
    d: "M45.419,6.251l-.15.438a.573.573,0,0,0,.224.675.272.272,0,0,0,.165.037.425.425,0,0,0,.389-.31l.15-.438a2.283,2.283,0,0,0-.224-1.972,1.072,1.072,0,0,1-.06-1.041l.18-.365a.6.6,0,0,0-.135-.712.387.387,0,0,0-.583.164l-.18.365a2.312,2.312,0,0,0,.12,2.227A1.12,1.12,0,0,1,45.419,6.251Z",
    transform: "translate(-40.39 -2.488)",
    fill: "#deaa0c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnBreak);
export default __webpack_public_path__ + "static/media/OnBreak.83cc340e60216ecad4b3fae768ac420b.svg";
export { ForwardRef as ReactComponent };